import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { loadJS } from 'utils/loadPlayerJSFiles';
import {
  loadLitePlayerJSFiles,
  setSlikeConfig,
  handleEvents,
  playerErrorCallback,
  playerloadError,
  attachEventsToJS,
} from './util';
import { processLitePlayerFnQueue, getApiKey } from './helper';

const Player = props => {
  const {
    divId,
    slikeId,
    isMobile,
    videoClassName,
    globalRefId,
    isEtimes,
    isFullPlayer,
    skipDiv,
    pageType,
    isPrime,
  } = props;

  useEffect(() => {
    if (
      props.useVdoPlayer ||
      (globalRefId && globalRefId === 'minitv' && pageType === 'ARTICLESHOW')
    ) {
      let isCancelled = false;
      const fetchVdoSources = async () => {
        try {
          const currentSlikeId = props.slikeId || '';
          if (currentSlikeId.length >= 6) {
            const prefixPart1 = currentSlikeId.slice(2, 4);
            const prefixPart2 = currentSlikeId.slice(4, 6);
            const tvIdApiUrl = `https://tvid.in/api/mediainfo/${prefixPart1}/${prefixPart2}/${currentSlikeId}/${currentSlikeId}.json`;
            if (
              globalRefId &&
              globalRefId === 'minitv' &&
              pageType === 'ARTICLESHOW'
            ) {
              window.miniTvVideoUrlAPI = tvIdApiUrl;
            } else {
              window.videoUrlAPI = tvIdApiUrl;
            }
            window.skipAdsVDO = isPrime;
          }
          if (!isCancelled) {
            if (props.useVdoPlayer) {
              window.vdoHlsUrl = [
                {
                  //video: videoUrl,
                  img: props.vdoImageUrl ? props.vdoImageUrl : '',
                },
              ];
              loadJS(
                '//a.vdo.ai/core/v-m-timesofindia-v3/vdo.ai.js',
                'vdo_ai_js',
              );
            }
            if (
              globalRefId &&
              globalRefId === 'minitv' &&
              pageType === 'ARTICLESHOW'
            ) {
              loadJS(
                '//a.vdo.ai/core/v-m-timesofindia-v4/vdo.ai.js',
                'vdo_ai_js_v4',
              );
              setTimeout(() => {
                window.vdo_ai_ = window.vdo_ai_ ? window.vdo_ai_ : {};
                window.vdo_ai_.cmd = window.vdo_ai_.cmd || [];
                window.vdo_ai_.cmd.push(() => {
                  window.vdo_ai_.show('v-m-timesofindia-v4');
                });
              }, 3000);
            }
          }
        } catch (e) {
          //
        }
      };
      fetchVdoSources();
      return () => {
        isCancelled = true;
      };
    }

    const pageProps = {
      isMobile,
      isEtimes,
      isFullPlayer,
    };
    const { Channel } = window?.Times?.adsKeys || {};
    if (Channel === 'etimes') {
      pageProps.isEtimes = true;
    }
    const apiKey = getApiKey(pageProps);
    pageProps.apiKey = apiKey;
    window.lwPlayer = window.lwPlayer || {};
    let player = window.lwPlayer[globalRefId];
    window.lwplayerConfig = window.lwplayerConfig || {};
    window.lwplayerConfig[globalRefId] =
      window.lwplayerConfig[globalRefId] || {};

    const afterPlayerLoaded = recheckCount => {
      const CleoPlayer = window?.CleoPlayer;
      if (CleoPlayer) {
        const slikeConfig = setSlikeConfig(props, pageProps);
        if (!slikeConfig) {
          return;
        }
        analyticsWrapper('ga4', {
          event: 'player_load',
          status: 'success',
          video_template: props.tmplSource,
        });
        processLitePlayerFnQueue(globalRefId);

        window.lwPlayer[globalRefId] = new CleoPlayer(slikeConfig, error => {
          if (error) {
            console.error(error);
            playerErrorCallback(error, props);
            return;
          }
          player = window.lwPlayer[globalRefId];
          handleEvents(player, CleoPlayer.Events, props);
        });
      } else if (recheckCount > 3) {
        playerloadError('CleoPlayer not found');
        console.error('CleoPlayer not found');
      } else {
        setTimeout(() => {
          afterPlayerLoaded(recheckCount + 1);
        }, 3000 * recheckCount);
      }
    };
    const lwMinitvObj = window?.lwObj && window.lwObj[globalRefId];

    if (player && lwMinitvObj) {
      attachEventsToJS(player, globalRefId, props);
      processLitePlayerFnQueue(globalRefId);
    } else {
      loadLitePlayerJSFiles(pageProps, () => {
        afterPlayerLoaded(1);
      });
    }
    return undefined;
  }, []);

  if (!slikeId || !divId || skipDiv) {
    return null;
  }
  if (props.useVdoPlayer) {
    return (
      <div id={divId} className={videoClassName} suppressHydrationWarning>
        <div id="v-m-timesofindia-v3" />
      </div>
    );
  }
  if (globalRefId && globalRefId === 'minitv' && pageType === 'ARTICLESHOW') {
    return (
      <div id={divId} className={videoClassName} suppressHydrationWarning>
        <div id="v-m-timesofindia-v4" />
      </div>
    );
  }
  return (
    <div
      id={divId}
      className={videoClassName}
      dangerouslySetInnerHTML={{ __html: '' }}
      suppressHydrationWarning
    />
  );
};
const mapStateToProps = state => ({
  isMobile: state.isMobile,
  isPrime: state.isPrime,
});
Player.propTypes = {
  divId: PropTypes.string.isRequired,
  slikeId: PropTypes.string.isRequired,
  videoClassName: PropTypes.string,
  globalRefId: PropTypes.string,
  isMobile: PropTypes.bool,
  isEtimes: PropTypes.bool,
  isFullPlayer: PropTypes.bool,
  skipDiv: PropTypes.bool,
  tmplSource: PropTypes.string,
  useVdoPlayer: PropTypes.bool,
  vdoImageUrl: PropTypes.string,
  pageType: PropTypes.string,
  isPrime: PropTypes.bool,
};
Player.defaultProps = {
  isMobile: false,
  videoClassName: '',
  globalRefId: 'common',
  isEtimes: false,
  isFullPlayer: false,
  skipDiv: false,
  tmplSource: '',
  useVdoPlayer: false,
  vdoImageUrl: '',
  pageType: '',
  isPrime: false,
};
export default connect(mapStateToProps)(Player);
